<div
  class="pagination"
  *ngIf="countPages >= 1"
  fxLayout="column"
  fxLayoutAlign="center center"
  fxLayoutGap="10px"
  fxLayout.gt-sm="row"
>
  <!-- back button -->
  <button *ngIf="currentIndex != 0" (click)="goToPage(currentIndex - 1)" class="dark-grey-button pagination-button">
    Zurück
  </button>

  <div fxLayout="row wrap" fxLayoutGap="5px">
    <div *ngFor="let button of buttons" class="pagination-button">
      <button
        *ngIf="button != currentIndex && button != -10"
        (click)="goToPage(button)"
        class="pagination-button dark-grey-button"
      >
        {{ button + 1 }}
      </button>
      <div *ngIf="button == currentIndex && button != -10" class="pagination-button active">
        {{ button + 1 }}
      </div>
      <div *ngIf="button == -10" class="spacer">...</div>
    </div>
  </div>

  <!-- next button -->
  <button
    *ngIf="currentIndex != countPages - 1"
    (click)="goToPage(currentIndex + 1)"
    class="dark-grey-button pagination-button"
  >
    Weiter
  </button>
</div>
